module.exports = __webpack_public_path__ + "static/img/news-d2.0fb3d9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news-d2.jpg
// module id = Ol0t
// module chunks = 1